if (!customElements.get('search-page')) {
  class SearchPage extends HTMLElement {
    connectedCallback() {
      this.panelSectionId = this.dataset.sectionId || 'search-results-panel';
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.terms = this.dataset.terms || '';

      this.querySelectorAll('[data-lazy-panel]').forEach((panel) => {
        this.loadPanel(panel.dataset.lazyPanel, panel);
      });
    }

    /**
     * Fetches article or page results into a tab panel.
     * @param {string} type - 'article' or 'page'.
     * @param {Element} panel - Tab panel element.
     */
    async loadPanel(type, panel) {
      if (!panel || !this.terms) return;
      if (panel.dataset.loaded === 'true' || panel.dataset.loaded === 'loading') return;

      panel.dataset.loaded = 'loading';
      panel.classList.add('is-loading');

      const params = new URLSearchParams({
        q: this.terms,
        type,
        section_id: this.panelSectionId,
        'options[prefix]': 'last'
      });

      try {
        const response = await fetch(`${this.searchUrl}?${params.toString()}`);

        if (!response.ok) throw new Error(`Search panel fetch failed (${response.status})`);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const sectionEl = tmpl.content.querySelector(`#shopify-section-${this.panelSectionId}`)
          || tmpl.content.querySelector('.cc-search-results-panel');

        if (!sectionEl || !sectionEl.innerHTML.trim()) {
          throw new Error('Search panel section missing from response');
        }

        panel.innerHTML = sectionEl.innerHTML;
        panel.dataset.loaded = 'true';
      } catch (error) {
        const message = panel.dataset.errorMessage || 'Unable to load results.';
        panel.innerHTML = `<p class="search-results-tabs__empty">${message}</p>`;
        panel.dataset.loaded = 'error';
        console.warn(error); // eslint-disable-line no-console
      } finally {
        panel.classList.remove('is-loading');
      }
    }
  }

  customElements.define('search-page', SearchPage);
}
